<template>
  <CardsGrid :columns="3">
    <BaseCard v-for="integration in integrations" :key="integration.key" class="text-center border">
      <!-- Logo -->
      <div class="w-40 h-40 bg-white rounded-lg flex items-center justify-center mx-auto mb-6 p-4 shadow-sm border">
        <img 
          :src="integration.logo" 
          :alt="`${integration.name} logo`"
          class="w-full h-full object-contain"
        />
      </div>
      
      <!-- Content -->
      <p class="text-muted text-base mb-6 leading-relaxed">{{ $t(integration.description) }}</p>
      
      <!-- Status badge -->
      <div class="flex items-center justify-center gap-2">
        <div class="w-3 h-3 bg-green-500 rounded-full"></div>
        <span class="text-base text-green-600 font-semibold">{{ $t('integrations.status.connected') }}</span>
      </div>
    </BaseCard>
  </CardsGrid>
</template>

<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import CardsGrid from './CardsGrid.vue'
import { integrations } from '@/data/integrations'
</script>